const types = {
  INIT: "INIT",
  FETCHING: "FETCHING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  TOGGLE_VIEW: "TOGGLE_VIEW",
  SET_APP_SCHEME: "SET_APP_SCHEME",
  GET_APP_SCHEME: "GET_APP_SCHEME"
};

export default types;
